const en_sales_refItemIn = {
    error: {
        reject: "Failed to cancel DO IN.",
    },

    success: {
        reject: "DO IN cancelled successfully.",
    },
}

export default en_sales_refItemIn;